import React, { useEffect, useState } from 'react';

const TFN = '+1 (888) 778-8606';
const TEL = 'tel:+18887788606';

const POPUP_DISABLED = true;

export default function AirlineCallPopup({ name, logo, logoNode, code, message }) {
  const [mounted, setMounted] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (POPUP_DISABLED) return undefined;
    if (window.matchMedia('(min-width: 768px)').matches) return undefined;

    const openTimer = setTimeout(() => {
      setMounted(true);
    }, 1800);

    return () => clearTimeout(openTimer);
  }, [code, name]);

  useEffect(() => {
    if (!mounted) return undefined;
    const raf = requestAnimationFrame(() => setShow(true));
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      cancelAnimationFrame(raf);
      document.body.style.overflow = prevOverflow;
    };
  }, [mounted]);

  const close = () => {
    setShow(false);
    setTimeout(() => setMounted(false), 250);
  };

  if (!mounted) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Call ${name}`}
      className={`md:hidden fixed inset-0 z-[70] flex flex-col items-center justify-center bg-white transition-opacity duration-300 ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <button
        onClick={close}
        aria-label="Close"
        className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 text-xl"
        style={{ top: 'calc(1rem + env(safe-area-inset-top))' }}
      >
        ✕
      </button>

      <div
        className={`flex flex-col items-center text-center px-8 w-full max-w-sm transition-all duration-300 ease-out ${
          show ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
        }`}
      >
        <div className="bg-white border border-gray-100 rounded-2xl p-4 shadow-sm mb-6">
          {logoNode || <img src={logo.src} alt={logo.alt} className="h-14 w-auto max-w-[220px] object-contain" />}
        </div>
        <p className="font-extrabold text-gray-900 text-2xl leading-snug">{name}</p>
        <p className="text-gray-500 text-base mt-2 mb-8">
          {message || 'Call now for exclusive fares & live agent support, 24/7.'}
        </p>
        <a
          href={TEL}
          onClick={close}
          className="w-full inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-navy-950 font-bold text-lg py-4 rounded-xl shadow-sm"
        >
          <svg className="w-5 h-5 shrink-0 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
          </svg>
          Call Now: {TFN}
        </a>
        <button
          onClick={close}
          className="mt-5 text-sm text-gray-400 hover:text-gray-600 font-medium"
        >
          No thanks, continue browsing
        </button>
      </div>
    </div>
  );
}
